import React from "react";
import ErrorMessage from "components/error-message";
import clsx from "clsx/lite";

const Input = ({ id, type = "text", name, placeholder, value, label, error, showError = true, className, ...other }) => (
	<div className={clsx(className, "relative")}>
		<label htmlFor={id || name}
			className={clsx("label absolute text-xs top-0 left-1.5 p-3", error ? "text-red-500" : "text-gray-600")}>
			{label}
		</label>
		<input
			name={name}
			type={type}
			placeholder={placeholder}
			defaultValue={value}
			{...other}
			className={clsx(
				"border focus:outline-beige shadow p-3 w-full pl-4 disabled:opacity-50 disabled:cursor-not-allowed",
				error ? "border-red-500" : "border-beige",
				value ? "border-opacity-100" : "border-opacity-30",
				label && "pt-7"
			)}
		/>
		{error && showError && <ErrorMessage message={error} />}
	</div>
);

export default Input;
